// base
export * from "./logo";
export * from "./code";
export * from "./search";
export * from "./docs-title";
export * from "./code-preview";
export * from "./color-palette";
export * from "./framework-card";

// layout
export * from "./layout/navbar";
export * from "./layout/footer";
export * from "./layout/sidenav";
export * from "./layout/page-map";
export * from "./layout/docs-navbar";

// icons
export * from "./icons/astro";
export * from "./icons/cra";
export * from "./icons/gatsby";
export * from "./icons/next";
export * from "./icons/remix";
export * from "./icons/vite";
export * from "./icons/vue";
export * from "./icons/react";
export * from "./icons/angular";
export * from "./icons/django";
export * from "./icons/flask";
export * from "./icons/laravel";
export * from "./icons/meteor";
export * from "./icons/nuxt";
export * from "./icons/phoenix";
export * from "./icons/qwik";
export * from "./icons/solid";
export * from "./icons/svelte";
export * from "./icons/symfony";

// sections
export * from "./sections/pro";
export * from "./sections/hero";
export * from "./sections/figma";
export * from "./sections/features";
export * from "./sections/community";
export * from "./sections/subscribe";
export * from "./sections/components";
export * from "./sections/integrations";
export * from "./sections/back-to-school/hero";
export * from "./sections/back-to-school/features";
export * from "./sections/back-to-school/templates";
export * from "./sections/back-to-school/pricing";
export * from "./sections/back-to-school/faq";
